import * as THREE from 'three';

export const NODE_CORE_RADIUS = 0.155;
export const NODE_DISK = new THREE.CircleGeometry(NODE_CORE_RADIUS, 64);

export function wantsHalo(node) {
  return !!(node?.isAvailable || node?.statusCategory === 'in_progress');
}

/** World scale used for rims, hits, and titles — ignores hover / pulse pop. */
export function layoutScaleOf(mesh) {
  const s = mesh?.userData?.layoutScale;
  if (s > 0) return s;
  return Math.max(mesh?.scale.x ?? 0, mesh?.userData?.nodeMeta?.size ?? 1, 0.001);
}

export function nodeRim(mesh) {
  const disk = mesh?.userData?.diskScale;
  if (disk > 0) return NODE_CORE_RADIUS * disk;
  return NODE_CORE_RADIUS * layoutScaleOf(mesh);
}
